import { GbApiRequestService } from "@/services/ApiRequestService";

export abstract class SignOutFormApi {
  static async signOut() {
    const response = GbApiRequestService.post(
      "rlogin",
      {
        requestType: "logout",
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      },
    );

    return response;
  }
}
